import { lazyRouteComponent } from "@tanstack/react-router";
import type { At } from "../../router";

export const MarketingRoutes = (at: At) => [
  at("/marketing", lazyRouteComponent(() => import("./Marketing"), "CampaignsPage")),
  at("/marketing/templates", lazyRouteComponent(() => import("./Marketing"), "TemplatesPage")),
  at("/marketing/templates/$id", lazyRouteComponent(() => import("./Marketing"), "TemplateEditor")),
  at("/marketing/segments", lazyRouteComponent(() => import("./Marketing"), "SegmentsPage")),
  at("/marketing/lists", lazyRouteComponent(() => import("./Marketing"), "ListsPage")),
  at("/marketing/forms", lazyRouteComponent(() => import("./Marketing"), "FormsPage")),
  at("/marketing/automations", lazyRouteComponent(() => import("./Marketing"), "AutomationsPage")),
];
